import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { timeOffService } from '../api/time-off.service';
import { TIME_OFF_KEYS } from './queryKeys';

/** Requester only. Releases any advanced-out days back to the next cycle. */
export function useCancelTimeOffRequest() {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useMutation({
    mutationFn: (requestId: string) => timeOffService.cancelRequest(requestId),
    onSuccess: (_data, requestId) => {
      queryClient.invalidateQueries({ queryKey: ['time-off', 'me', 'requests', orgId] });
      queryClient.invalidateQueries({ queryKey: TIME_OFF_KEYS.myBalance(orgId) });
      queryClient.invalidateQueries({ queryKey: TIME_OFF_KEYS.request(orgId, requestId) });
    },
  });
}
